import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Button from "common/components/Button/Button"
import Modal from "common/components/Modal/Modal"
import {
  setShowLogoutModal,
  userSelector,
} from "features/User/redux/slices/userSlice"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"

const UserIsAlreadyConnectedModal = () => {
  const { showLogoutModal } = useSelector(userSelector)
  const dispatch = useDispatch()

  const closeModal = () => dispatch(setShowLogoutModal(false))

  return (
    <Modal
      closable={false}
      size='small'
      visible={showLogoutModal}
    >
      <div className='d-flex align-items-center flex-column px-3'>
        <FontAwesomeIcon
          icon={["fal", "circle-info"]}
          className='mb-2'
        />
        <h5 className='text-secondary f-28 f-weight-500 text-center'>
          ¡Su sesión ha sido cerrada!
        </h5>
        <p className='text-center mt-1'>
          {/* TODO: i18n */}
          Se ha iniciado sesión en otro navegador o dispositivo.
        </p>
        <Button
          onClick={closeModal}
          label='Entendido'
        />
      </div>
    </Modal>
  )
}

export default UserIsAlreadyConnectedModal
